import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Row, Col, Card, CardHeader, Button } from "reactstrap"
import { saveCourierEnabledConfiguration } from "../../apollo/server"
import { useMutation, gql } from "@apollo/client"
import { Alert } from "reactstrap/lib"

interface IProps {
  courierEnabled: boolean
}

// 何でも配送(お使い便)のフィーチャーフラグ。ON にすると顧客アプリのメニューに
// 「何でも配送」が表示され、注文できるようになる。
const CourierEnabled: React.FC<IProps> = props => {
  const { t } = useTranslation()
  const [courierEnabled, setCourierEnabled] = useState(props.courierEnabled)
  const [successMessage, setSuccessMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  const [save, { loading, error }] = useMutation(gql`${saveCourierEnabledConfiguration}`, {
    onCompleted: result => {
      setSuccessMessage(result.saveCourierEnabledConfiguration.courierEnabled ? t("CourierEnabledOnMessage") : t("CourierEnabledOffMessage"))
    },
    onError: e => {
      setErrorMessage(t("ErrorMessage"))
      console.log(e)
    },
  })
  if (error) return <p>{t("Error")}</p>

  function submit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault()
    if (loading) return
    save({ variables: { courierEnabled } })
  }

  const onDismiss = () => {
    setSuccessMessage("")
    setErrorMessage("")
  }

  return (
    <Row className="mt-3">
      <div className="col">
        <Card className="shadow">
          <CardHeader className="border-0">
            <h3 className="mb-0">{t("CourierEnabledTitle")}</h3>
            <small className="text-muted">{t("CourierEnabledHint")}</small>
          </CardHeader>

          <Row className="ml-3 mr-3" style={{ display: "flex", alignItems: "center" }}>
            <Col md="10">
              <label className="custom-toggle">
                <input
                  name="input-courier-enable"
                  checked={courierEnabled}
                  type="checkbox"
                  onChange={e => setCourierEnabled(e.target.checked)}
                />
                <span className="custom-toggle-slider rounded-circle" />
              </label>
            </Col>
            <Col md="2">
              <Button className="btn-block mb-2" type="button" color="primary" onClick={submit} size="lg">
                {loading ? t("Saving") : t("Save")}
              </Button>
            </Col>
          </Row>
          <Row className="mx-3" style={{ display: "flex", justifyContent: "flex-end" }}>
            <Col md="6">
              <Alert color="success" isOpen={!!successMessage} toggle={onDismiss}>
                <span className="alert-inner--icon">
                  <i className="ni ni-like-2" />
                </span>{" "}
                <span className="alert-inner--text" style={{ whiteSpace: "pre-wrap" }}>
                  <strong>{t("Success")}! </strong>
                  {successMessage}
                </span>
              </Alert>
              <Alert color="danger" isOpen={!!errorMessage} toggle={onDismiss}>
                <span className="alert-inner--icon">
                  <i className="ni ni-like-2" />
                </span>{" "}
                <span className="alert-inner--text">
                  <strong>{t("Danger")}!</strong> {errorMessage}
                </span>
              </Alert>
            </Col>
          </Row>
        </Card>
      </div>
    </Row>
  )
}
export default CourierEnabled
